import { render, staticRenderFns } from "./ProductHistoryDialog.vue?vue&type=template&id=ec24ddfe&"
import script from "./ProductHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./ProductHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports